import React, { useEffect } from 'react';
//*MUI
import { Box, Modal, Divider } from '@mui/material';
//*files
import cssClasses from "./ChangeBookingAmountModal.module.css"
import Button from '../../../../Subcomponents/Button';
import Close from '../../../../Components/Icons/Close';
import { errorTost, infoTost, successTost } from '../../../../Services/Toast';
import CustomInput from '../../../../Subcomponents/CustomInput';
import { useState } from 'react';
import { ChangeBookingAmountValues, insertCRMLogs, insertUpdatedBookingAmountLogs } from '../../../../Services/AllAllotments';
import { bucketingForChangeUnit } from '../../../../Services/PaymentApi';
import { useSelector } from "react-redux";
import { dismissLoader, presentLoader } from '../../../../Services/loader';
import { updateLeadAllStatus } from '../../../../Services/Lead';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '35%',
  height: 'fit-Content',
  bgcolor: 'background.paper',
  borderRadius: '8px',
  boxShadow: 24,
};

// crm2 (M5-F8, CRM 2.0 bookings only): { submit({ ocr, sdr }) } — the server checks that stamp duty & charges are
// unpaid, works out GST (1% of OCR below ₹45 L, else 5%), keeps the booking Applied and logs it.
function ChangeBookingAmountModal({ open, handleClose, allotment, getCrmAllotmentsFromServer, crm2 = null }) {
  const [newOcr, setNewOcr] = useState("");
  const [newGst, setNewGst] = useState("");
  const [newSdr, setNewSdr] = useState("");
  const [newBookingAmount, setNewBookingAmount] = useState(0);
  const [helperText, setHelperText] = useState("");
  const loggedInUser = useSelector((state) => state.Auth.user);

  useEffect(()=>{
    setNewBookingAmount(Number(newOcr) + Number(newGst) + Number(newSdr));
  },[newOcr, newSdr, newGst])

  // CRM 2.0: GST filled by the system as today's rule — 1% of OCR when the agreement value is below ₹45 lakh, else 5%
  useEffect(() => {
    if (!crm2) return;
    const bsp = Number(allotment?.unitcost?.bsp) || 0;
    setNewGst(Math.round((Number(newOcr) || 0) * (bsp < 4500000 ? 1 : 5) / 100));
  }, [crm2, newOcr, allotment?.unitcost?.bsp]);

  function updateChangedBookingAmount(updatedbookingAmount) {
    if (crm2) {
      presentLoader();
      console.log("[crm2][ChangeBookingAmountModal] submit", { allotmentPaymentId: allotment?.allotment_payment_id, ocr: updatedbookingAmount.ocr });
      crm2
        .submit({ ocr: Number(updatedbookingAmount.ocr), sdr: Number(updatedbookingAmount.sdr) || 0 })
        .then(() => {
          successTost("Booking amount updated successfully!");
          getCrmAllotmentsFromServer && getCrmAllotmentsFromServer(false);
          handleClose();
        })
        .catch((err) => {
          const message = err?.response?.data?.message || "Booking amount not updated. Please try again.";
          console.error("[crm2][ChangeBookingAmountModal] failed", { status: err?.response?.status, message });
          errorTost(message);
        })
        .finally(() => dismissLoader());
      return;
    }
    presentLoader();
    const body = {
      allotmentPaymentId: allotment?.allotment_payment_id,
    };
    let allotmentStatus;
    if(allotment?.allotment_payment_paid_amount >= updatedbookingAmount?.total){
      allotmentStatus = "Payment Complete";
    }else if(allotment?.allotment_payment_paid_amount !== 0 && allotment?.allotment_payment_paid_amount < updatedbookingAmount?.total){
      allotmentStatus = "Partial Payment Done";
    }else  if(allotment?.allotment_payment_paid_amount === 0){
      allotmentStatus = "Payment Pending";
    }
    //Update Value and Allotment Status in AllotmentPayment Amount
    ChangeBookingAmountValues(updatedbookingAmount, allotmentStatus, allotment?.allotment_payment_id)
      .then((res) => {
      //Update Status in LeadStatus
      updateLeadAllStatus(allotment?.lead_id, 
        allotment?.allotment_payment_paid_amount !== 0
          ? allotment?.allotment_payment_paid_amount > allotment?.updatedbookingAmount?.total
            ? "Allotment Payment Complete" 
            : "Allotment Partial Payment Done"
          : "Allotment Payment Pending"
      ).then((res)=>{
          //Apply bucketing
          bucketingForChangeUnit(body)
          .then((bucketingResp) => {
            if (bucketingResp?.data?.success) {
              //Maintain logs for changes in booking amount value
              const obj = {
                oldBookingAmt: allotment?.bookingamt,
                newBookingAmt: updatedbookingAmount,
                userId: loggedInUser?.userId,
                allotmentPaymentId: allotment?.allotment_payment_id,
                crmStatusId : allotment?.crm_status_id
              };
                insertUpdatedBookingAmountLogs(obj).then((res) => {
                  console.log(res);
                  successTost("Booking amount updated successfully!");
                  dismissLoader();
                  getCrmAllotmentsFromServer(false);
                  handleClose();

                  const crmObj = {
                    message: `Booking amount is changed from ${allotment?.bookingamt?.total} to ${updatedbookingAmount?.total} by ${loggedInUser?.name} for allotment unit ${allotment?.unit_no} of project ${allotment?.project_name}`,
                    allotmentPaymentId: allotment?.allotment_payment_id,
                    crmStatus: "Changed booking amount",
                  };
                  insertCRMLogs(crmObj).then((res) => {
                      console.log("Logs saved", res);
                  }).catch((err) => {
                      console.log(err);
                  });
              })
              .catch((err) => {
                console.log(err);
                dismissLoader();
                errorTost(err);
                handleClose();
              });
          } else {
            errorTost(bucketingResp?.data?.message);
            dismissLoader();
            handleClose();
          }
        })
        .catch((err) => {
          errorTost(err);
          dismissLoader();
          handleClose();
          console.log(err);
        });
      }).catch((err) => {
        errorTost(err);
        dismissLoader();
        handleClose();
        console.log(err);
      })
      })
      .catch((err) => {
        console.log("ERROR", err);
        dismissLoader();
        errorTost("Error in updating booking amount.");
        handleClose();
      });
  }

  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          handleClose();
        }}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style}>
          <Box className={cssClasses.headerDiv}>
            <Box className={cssClasses.flexRow}>
              <Box className={cssClasses.flexCol}>
                <Box className={cssClasses.flexRow}>
                  <Box className={cssClasses.HeaderTitle}>Old Value</Box>
                </Box>
              </Box>
              <Box ml={'auto'} mt={1} onClick={handleClose} style={{ cursor: "pointer" }}>
                <Close width={'1.2rem'} height={'1.2rem'} />
              </Box>
            </Box>
          </Box>

          <Box width={'100%'} height={'49%'} overflow={'auto'}>
            <Box paddingX={"3rem"} backgroundColor={"#F9FAFB"}>
                <div style={{width: "100%", height: "100%", color : "#515A6B", fontWeight : "600", fontSize : "16px", lineHeight : "26px"}}>
                  <div className={cssClasses.ThirdDivRow}>
                    <div>OCR</div>
                    <div>₹ {numberWithCommas(allotment?.bookingamt?.ocr)}</div>
                  </div>
                  {/* <Divider/> */}
                  <div className={cssClasses.ThirdDivRow}>
                    <div>SDR</div>
                    <div>₹ {numberWithCommas(allotment?.bookingamt?.sdr)}</div>
                  </div>
                  {/* <Divider/> */}
                  <div className={cssClasses.ThirdDivRow}>
                    <div>GST</div>
                    <div>₹ {numberWithCommas(allotment?.bookingamt?.gst)}</div>
                  </div>
                  {/* <Divider/> */}
                  <div className={cssClasses.ThirdDivRow}>
                    <div>Booking Amount</div>
                    <div>₹ {numberWithCommas(allotment?.bookingamt?.total)}</div>
                  </div>
                </div>
            </Box>
            <Box className={cssClasses.headerDiv}>
              <Box className={cssClasses.flexRow}>
                <Box className={cssClasses.flexCol}>
                  <Box className={cssClasses.flexRow}>
                    <Box className={cssClasses.HeaderTitle}>New Value</Box>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box paddingX={"3rem"} backgroundColor={"#F9FAFB"}>
              <div style={{width: "100%", height: "100%", color : "#515A6B", fontWeight : "600", fontSize : "16px", lineHeight : "26px"}}>
                <div className={cssClasses.ThirdDivRow}>
                  <label>OCR <sup style={{ color: "red", fontSize: "1.2rem" }}>*</sup></label>
                  <div style={{width : "50%"}}>
                    <CustomInput
                      placeholder="Enter Value"
                      value={newOcr}
                      helperText={helperText}
                      handleChange={(_value) => {
                        if (!isNaN(_value)) {
                          setNewOcr(_value);
                        }
                        if(parseInt(_value) === 0) {
                          setHelperText("Please enter ocr value");
                        } else {
                          setHelperText("");
                        }
                      }}
                    />
                  </div>
                </div>
                {/* <Divider/> */}
                <div className={cssClasses.ThirdDivRow}>
                  <label>SDR</label>
                  <div style={{width : "50%"}}>
                    <CustomInput
                      placeholder="Enter Value"
                      value={newSdr}
                      handleChange={(_value) => {
                        if (!isNaN(_value)) {
                          setNewSdr(_value);
                        }
                      }}
                    />
                  </div>
                </div>
                {/* <Divider/> */}
                <div className={cssClasses.ThirdDivRow}>
                  <label>GST</label>
                  <div style={{width : "50%"}}>
                    <CustomInput
                      placeholder="Enter Value"
                      value={newGst}
                      disabled={!!crm2}
                      handleChange={(_value) => {
                        if (!isNaN(_value)) {
                          setNewGst(_value);
                        }
                      }}
                    />
                  </div>
                </div>
                {/* <Divider/> */}
                <div className={cssClasses.ThirdDivRow}>
                  <label>Booking Amount</label>
                  <div style={{width : "50%"}}>
                    <CustomInput
                      placeholder="Booking Amount"
                      value={newBookingAmount}
                      disabled={true}
                    />
                  </div>
                </div>
              </div>
            </Box>
          </Box>

          <Box className={cssClasses.FooterDiv}>
            <Box className={cssClasses.flexRow}>
              <Box width={'fit-Content'} ml={'auto'}>
                <Button
                  style={{
                    fontSize: '1.4rem',
                    lineHeight: '2rem',
                    color: '#344054',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '0.8rem',
                  }}
                  padding={'0.85rem 2.6rem'}
                  btnName={'Cancel'}
                  clicked={handleClose}
                />
              </Box>

              <Box width={'fit-Content'}>
                <Button
                  style={{
                    fontSize: '1.6rem',
                    lineHeight: '2.4rem',
                    color: '#FFF',
                    backgroundColor: "#006AFF",
                    borderRadius: '0.8rem',
                  }}
                  padding={'0.65rem 3.2rem'}
                  btnName={'Update'}
                  disable={newOcr === "" || parseInt(newOcr) === 0}
                  clicked={()=>  updateChangedBookingAmount({
                    "ocr": newOcr,
                    "gst": newGst || 0,
                    "sdr": newSdr || 0,
                    "total": newBookingAmount
                  })}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  )
}

export default ChangeBookingAmountModal;

function numberWithCommas(x) {
	return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
}
